export function LoadingRing() {
  return (
    <div className="loading-ring" aria-label="Loading...">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}
